import GattaranHost from '@didi/gattaran-plugin-gateway-default-host';
import { session } from '@/utils';
import { IS_PRE, IS_PRE_API, IS_SODA } from './constants';

const { NODE_ENV, VUE_APP_BUILD_ENV } = process.env;
let env = IS_SODA ? 'development' : NODE_ENV;

/**
 * 由于我们没有切换pre构建的兼容写法
 */
if (IS_PRE && IS_PRE_API) {
  env = 'pre';
} else if (IS_PRE) {
  env = 'production';
}

const apiConfig = {
  development: {
    gateway: '',
    pms: 'http://10.179.90.85:8520',
    api: '',
    dilu_api: '',
    'banner-mis': '',
    'act-mis': 'http://10.179.133.206:8380',
    activation: '',
    depot: '',
    operations: '',
    dpc: '',
    'msgcenter-api': '',
    'supply-api': '',
    'm-transaction': '/m-transaction',
    'm-transaction-invoice': '/m-transaction',
    'm-transaction-rfc': '/m-transaction',
    deal: 'http://127.0.0.1:8108',
    dragonstone: '/dragonstone',
    'm-transaction-supply': '/m-transaction',
    workshop: 'http://10.96.86.120:8080',
  },
  test: {
    gateway: 'http://10.96.98.128:9999',
    pms: 'http://10.179.90.85:8520',
    api: 'http://10.96.78.133:8800',
    dilu_api: '',
    'banner-mis': '//act-api.didi-food.com',
    activation: '//10.96.88.242:8055',
    'act-mis': '//act-api.didi-food.com',
    depot: '//10.179.90.85:8651',
    operations: '//act-api.didi-food.com',
    'msgcenter-api': '//pre-act-api.didi-food.com',
    'm-transaction-invoice': '//pre-deal.didi-food.com',
    'm-transaction-supply': '//pre-deal.didi-food.com',
    'm-transaction-rfc': '//pre-deal.didi-food.com',
    deal: '//pre-deal.didi-food.com',
    dragonstone: '/',
    'supply-api': '//10.15.37.22:8095',
    workshop: 'http://10.96.112.104:8080',
  },
  pre: {
    gateway: '//pre-dilu.didi-food.com',
    pms: '//pre-crm.didi-food.com',
    api: '//pre-crm.didi-food.com',
    dilu_api: '//pre-dilu.didi-food.com',
    'banner-mis': '//pre-act-api.didi-food.com',
    activation: '//pre-activation.didi-food.com',
    'act-mis': '//pre-act-api.didi-food.com',
    depot: '//pre-crm.didi-food.com',
    'msgcenter-api': '//pre-act-api.didi-food.com',
    'm-transaction-invoice': '//pre-deal.didi-food.com',
    'm-transaction-rfc': '//pre-deal.didi-food.com',
    'm-transaction-supply': '//pre-deal.didi-food.com',
    deal: '//pre-deal.didi-food.com',
    'home-conf': '//home-conf.didi-food.com',
    workshop: '//pre-transaction-mis.didi-food.com',
  },
  production: {
    gateway: '//dilu.didi-food.com',
    pms: '//crm.didi-food.com',
    api: '//crm.didi-food.com',
    dilu_api: '//dilu.didi-food.com',
    'banner-mis': '//act-api.didi-food.com',
    activation: '//activation.didi-food.com',
    'act-mis': '//act-api.didi-food.com',
    depot: '//crm.didi-food.com',
    operations: '//act-api.didi-food.com',
    'msgcenter-api': '//act-api.didi-food.com',
    'm-transaction-invoice': '//deal.didi-food.com',
    'm-transaction-rfc': '//deal.didi-food.com',
    'm-transaction-supply': '//deal.didi-food.com',
    deal: '//deal.didi-food.com',
    'home-conf': '//home-conf.didi-food.com',
    workshop: '//transaction-mis.didi-food.com',
  },
};

export default GattaranHost.getHostConfig(env, apiConfig);
